import React, { JSX } from "react";
import Column from "antd/es/table/Column";
import { Tag } from "antd";
import { SorterResult } from "antd/es/table/interface";

export const renderDownloadSourceColumn = (
  renderColumnTitle: (title: string) => JSX.Element,
  sorter: SorterResult<any>,
): JSX.Element => {
  return (
    <Column
      key="Download_source"
      title={renderColumnTitle("Источник загрузки")}
      dataIndex="source"
      width={150}
      sorter={{ multiple: 3 }}
      sortOrder={sorter?.field === "source" ? sorter?.order : undefined}
      sortDirections={["ascend", "descend"]}
      showSorterTooltip={false}
      render={(value: string) => {
        const source: string = value === "manual" ? "Ручной" : value?.toUpperCase();

        return <Tag color="default">{source}</Tag>;
      }}
    />
  );
};
